import React from 'react'
import { Feed } from 'semantic-ui-react';
import momentDate from '../../../../../helpers/momentDate'
import momentTime from '../../../../../helpers/momentTime'
import ImageAvater from '../../../../drive/Components/ImageAvater';
import { dispatch } from '@rematch/core';
import { history } from "../../../../../helpers";
import EllipsisTooltip from '../../../../common/EllipsisTooltip';

class ActivityUserInfo extends React.Component {
    async handelUser(id, data) {
        await dispatch.home.redirectFromEventStream(true);
        let payload = {
            id: id,
            data: data
        }
        dispatch.community.setAddUserContextData('Users');
        await history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/userList/${this.props.selectedOrganisation.id}/users`)
        await dispatch.organizationUnit.isUserAvailable(payload);
    }

    render() {
        const { user, date, subCategory } = this.props
        return (
            <div className="ActivityUserInfo" >
                <Feed  >
                    <Feed.Event>
                        <div
                            style={{ width: "40px" }}
                            className="float-left"
                        >
                            <ImageAvater user={user} imageStyle="w_32 h_32" />
                        </div>

                        <Feed.Content className="w_100">
                            <Feed.Summary >
                                <EllipsisTooltip name={
                                    <label
                                    >
                                        {user.firstName} {user.lastName}
                                    </label>
                                }
                                    style={{ width: "calc(100% - 100px)", float: "left" }}
                                />
                                <span style={{ opacity: ".6" }}
                                    className="pull-right font-weight-normal" >
                                    {momentDate(date)}
                                </span>
                            </Feed.Summary>
                            <Feed.Date>
                                <span style={{
                                    float: "left",
                                    width: "calc(100% - 90px)"
                                }}>
                                    {subCategory ? subCategory : null}
                                </span>
                                <span className="pull-right font-weight-normal"
                                >
                                    {momentTime(date)}
                                </span>
                            </Feed.Date>
                        </Feed.Content>
                    </Feed.Event>

                </Feed>
            </div>
        )
    }
}

export default ActivityUserInfo;